const TRANSLATION_NAMESPACE = "error:surveys."

export const GET_SURVEYS_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}get-surveys-failed`
export const CREATE_SURVEY_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}create-survey-failed`
export const UPDATE_SURVEY_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}update-survey-failed`
export const DELETE_SURVEY_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}delete-survey-failed`
